import { PermissionUtil } from '@aon/aon-tws-common-ui';
import { User } from 'oidc-client';
import { getStringFromConfig } from '../constants';
import { UserType } from '../models';
import PermissionConstants from '../permissionConstants';

export const FeatureFlags = {
	EnableBranchingLogic: getStringFromConfig('REACT_APP_FEATURE_FLAG_BRANCHING_LOGIC') === 'true',
	EnablePublishDestination: getStringFromConfig('REACT_APP_FEATURE_FLAG_PUBLISH_DESTINATION') === 'true',
	EnableReportingBulkUsers: true,
	EnableReportingProfiles: true,
	EnableCopyFromTemplate: true,
	EnableResponseStream: true,
};

export interface IUserFeatureAccessHelper {
	CanUserAccessFeature: (feature: keyof typeof FeatureFlags) => boolean;
}

export class UserFeatureAccessHelper {
	private user: User | undefined;
	constructor(user: User | undefined) {
		this.user = user;
	}
	public CanUserAccessFeature = (feature: keyof typeof FeatureFlags) => CanUserAccessFeature(this.user, feature);
}

export function CanUserAccessFeature(user: User | undefined, feature: keyof typeof FeatureFlags) {
	switch (feature) {
		case 'EnableReportingBulkUsers':
		case 'EnableReportingProfiles': {
			const { application, resource, permission } = PermissionConstants.HIERARCHYREPORTING_ALL;
			return PermissionUtil.DoesUserHavePermission(application, resource, permission, user) && FeatureFlags[feature];
		}
		case 'EnableCopyFromTemplate':
		case 'EnableResponseStream':
			if (user?.profile.userType === UserType.Internal) {
				return FeatureFlags[feature];
			}
			return false;
		default:
			return FeatureFlags[feature];
	}
}
